import clsx from "clsx";
/**
 * 需支持 tailwindcss
 */
export default function Skeleton({ className }: { className: string }) {
	return <div className={clsx("animate-pulse bg-slate-200 dark:bg-black_25", className)}></div>;
}
